//Order by abc
export default {
    AJAX_AUTOCOMPLETE: 'AjaxAutocomplete',
    AUTOCOMPLETE_CHECKBOX: 'AutocompleteCheckboxButtons',
    AUTOCOMPLETE_CHECKBOX_WITH_AGE: 'AutocompleteCheckboxButtonsWithAge',
    CHECKBOX: 'CheckboxButtons',
    DATE_OF_BIRTH: 'DateOfBirth',
    DONT_KNOW_BTN: 'DontKnowBtn',
    DROPDOWN: 'DropDown',
    FAMILY_CANCER_HISTORY: 'FamilyCancerHistory',
    HEIGHT: 'Height',
    NUMBER_INPUT: 'NumberInput',
    MULTIBIRTH: 'Multibirth',
    PERSONS_ARRAY: 'PersonsArray',
    RADIO_BUTTONS: 'RadioButtons',
    SLIDER: 'Slider',
    SMALL_INPUT: 'SmallInput',
    TEXT_INPUT: 'TextInput',
    USER_COMMENTS: 'UserComments',
    WEIGHT: 'Weight',
    YES_NO_BUTTONS: 'YesNoButtons'
};
